import { boolean, defineAction, object } from '~/prix'
import legalEntityFetchAction from './legalEntityFetch.action.json' with { type: 'json' }

const legalEntityFetchDefinition = defineAction({
  ...legalEntityFetchAction,
  input: object({
    force: boolean().isOptional(),
    postProcessingOnly: boolean().isOptional(),
  }),
  output: object({}),
})

export default legalEntityFetchDefinition
